const platformBrandMap = {
  'alpha': 'alpha',
  'amey2_mci': 'amey',
  'cbre-demo': 'cbredemo',
  'bruton-knowles': 'brutonknowles',
  'bulleys-mci': 'bulleys',
  'cityscape': 'cityscape',
  'langtree': 'langtree',
  'mason-owen': 'masonowen',
  'metrolife': 'metrolife',
  'mojo': 'mojo',
  'rapleys': 'rapleys',
  'rem': 'rem',
  'roger-hannah-mci': 'rogerhannah',
  'rogroup_mfs': 'rogroup',
  'speirs-gumley': 'speirs',
  'stepnell': 'stepnell',
  'tpm': 'tpm',
  'workman': 'workman',
  'lisney': 'lisney',
  'adpt': 'adpt',
  'fisher-german': 'fishergerman',
  'graham-sibbald': 'grahamsibbald',
  'caxtons': 'caxtons',
  'cyan': 'cyan',
  'magenta': 'magenta',
  'helix': 'helix',
  'ashdown-phillips': 'ashdownphillips',
  'cobbs': 'cobbs',
  'carter-jonas': 'carterjonas',
  'breckon': 'breckon'
}

const brandLogos = {
  'theme-alpha': 'alpha/abt white.png',
  'theme-amey': 'amey2_mci/amey-consulting-logo.svg',
  'theme-cbredemo': 'cbre-demo/CBREdemologo.png',
  'theme-brutonknowles': 'bruton-knowles/navbar_logo.png',
  'theme-bulleys': 'bulleys-mci/bulleys-logo-mobile.png',
  'theme-cityscape': 'cityscape/navbar_logo.svg',
  'theme-langtree': 'langtree/navbar_logo.png',
  'theme-masonowen': 'mason-owen/mason-owen-logo-mobile.png',
  'theme-metrolife': 'metrolife/metrolife-logo-mobile.png',
  'theme-mojo': 'mojo/logo-outlined-white.png',
  'theme-rapleys': 'rapleys/rapleys_logo.png',
  'theme-rem': 'rem/rem-logo-mobile.jpg',
  'theme-rogerhannah': 'roger-hannah-MCI/navbar_logo.svg',
  'theme-rogroup': 'rogroup_mfs/ro-logo_silver2.png',
  'theme-speirs': 'speirs-gumley/nav-logo.png',
  'theme-stepnell': 'stepnell/stepnell_logo.png',
  'theme-tpm': 'tpm/navbar_logo.png',
  'theme-workman': 'workman/workman_logo.jpg',
  'theme-adpt': 'adpt/adpt-logo-mobile.png',
  'theme-lisney': 'lisney/lisney-logo-mobile.png',
  'theme-fishergerman': 'fisher-german/FisherGermanLogoOnWhite.png',
  'theme-grahamsibbald': 'graham-sibbald/login-logo.png',
  'theme-caxtons': 'caxtons/caxtons-logo-header.png',
  'theme-cyan': 'cyan/cyan-logo-header.png',
  'theme-magenta': 'magenta/magenta-logo-header.png',
  'theme-helix': 'helix/helix-logo-header.png',
  'theme-ashdownphillips': 'ashdown-phillips/mobileLogo.png',
  'theme-cobbs': 'cobbs/headerLogo.png',
  'theme-carterjonas': 'carter-jonas/CJ_Logo.png',
  'theme-breckon': 'breckon/mobileLogo.png'
}

//This is currently not being used. Please update app.config.ts instead when adding new themes
const themeConfigs = [];
for (const k in brandLogos) {
  themeConfigs.push({
    id: k,
    name: k.replace('theme-', '')
  })
}

module.exports = {
  brandLogos,
  platformBrandMap,
  themeConfigs
}
